import React, { createContext, useContext, useEffect, useState } from 'react';
import { SERVER_URL } from '../api';
import Cookies from 'js-cookie';
import { tokenData } from '../const';

const StatusContext = createContext()

export default function StatusProvider({ children }) {
    const [status, setStatus] = useState([])

    useEffect(() => {
        if (!tokenData?.token) return
        fetchStatus()
    }, []);

    const fetchStatus = () => {
        try {
            fetch(`${SERVER_URL + "status/get-all-status"}`, {
                headers: {
                    'Authorization': `Bearer ${tokenData?.token}`,
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    setStatus(data);
                })
                .catch((error) => {
                    console.log('Error fetching data:', error);
                });
        } catch (error) {
            console.log("Error: ", error)
        }
    }

    return (
        <StatusContext.Provider value={{ status }} >
            {children}
        </StatusContext.Provider>
    )
}

export function useStatusCode() {
    return useContext(StatusContext)
}